import _ from 'lodash'

export default function accorInitializeDsp2Payment(
	transactionToken,
	handlePspSessionId,
	submitReservationForm,
) {
	// const cardNumber = _.get(paymentFormData, 'values.creditCard', null)

	if (
		window.cardinal &&
		transactionToken &&
		transactionToken !== ''
	) {
		window.cardinal.configure({
			timeout: 100000,
			extendedtimeout: 50000,
			maxRequestRetries: 2,
			logging: {
				level: 'verbose'
			},
		})

		window.cardinal.setup('init', {
			"jwt": transactionToken.toString()
		})

		window.cardinal.on('payments.setupComplete', function(setupCompleteData) {
			const pspSessionId = _.get(setupCompleteData, 'sessionId', null)
			handlePspSessionId(pspSessionId)

			setTimeout(() => {
				submitReservationForm()
			}, 1500)
		})
	}
}


// WEBPACK FOOTER //
// ./src/utilities/payment/accorInitializeDsp2Payment.js